import script from "./chartDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./chartDetail.vue?vue&type=script&lang=ts&setup=true"

import "./chartDetail.vue?vue&type=style&index=0&id=64da83d7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64da83d7"]])

export default __exports__